export default __webpack_public_path__ + "static/media/share_twitter.b0cfb2b7.svg";